import { useState } from 'react';
import { getPacksButtonLabel } from '../../../../../../../orders/products/product/grid/components/orderProductGrid/utils/productGrid.utils';
import useOrderProductGridContext from '../../../../../../../orders/products/product/grid/contexts/OrderProductGrid.context';
import { useTranslation } from '../../../../../../../translation/TranslationContext';

const useCombinationPackChip = () => {
  const { translate } = useTranslation();
  const [isPacksMenuOpen, setIsPacksMenuOpen] = useState(false);

  const { selectedPacks, hasValidPacks, isOrderProductFromKit } = useOrderProductGridContext();

  const openPacksMenu = () => setIsPacksMenuOpen(true);

  const closePacksMenu = () => setIsPacksMenuOpen(false);

  return {
    isPacksMenuOpen,
    label: getPacksButtonLabel(selectedPacks, translate),
    canOpenPacksMenu: hasValidPacks && !isOrderProductFromKit,
    openPacksMenu,
    closePacksMenu,
  };
};

export default useCombinationPackChip;
